module.exports = __webpack_public_path__ + "sms_ico@2x.22ff7b1f3885317f73f81e0e534966aa.png";